"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontScale = void 0;
var polished_1 = require("polished");
var calc_space_1 = require("../scale/calc-space");
var index_1 = require("./index");
var getFontScale = function (n, scale, step) {
    if (scale === void 0) { scale = index_1.SCALE; }
    switch (n) {
        case 1: {
            return { size: "".concat((0, polished_1.rem)(scale[0])), lineHeight: (0, calc_space_1.calcSpace)(2, step) };
        }
        case 2: {
            return { size: "".concat((0, polished_1.rem)(scale[1])), lineHeight: (0, calc_space_1.calcSpace)(2, step) };
        }
        case 3: {
            return { size: "".concat((0, polished_1.rem)(scale[2])), lineHeight: (0, calc_space_1.calcSpace)(2.5, step) };
        }
        case 4: {
            return { size: "".concat((0, polished_1.rem)(scale[3])), lineHeight: (0, calc_space_1.calcSpace)(3, step) };
        }
        case 5: {
            return { size: "".concat((0, polished_1.rem)(scale[4])), lineHeight: (0, calc_space_1.calcSpace)(3.5, step) };
        }
        case 6: {
            return { size: "".concat((0, polished_1.rem)(scale[5])), lineHeight: (0, calc_space_1.calcSpace)(4, step) };
        }
        case 7: {
            return { size: "".concat((0, polished_1.rem)(scale[6])), lineHeight: (0, calc_space_1.calcSpace)(4, step) };
        }
        case 8: {
            return { size: "".concat((0, polished_1.rem)(scale[7])), lineHeight: (0, calc_space_1.calcSpace)(5, step) };
        }
        case 9: {
            return { size: "".concat((0, polished_1.rem)(scale[8])), lineHeight: (0, calc_space_1.calcSpace)(6, step) };
        }
        case 10: {
            return { size: "".concat((0, polished_1.rem)(scale[9])), lineHeight: (0, calc_space_1.calcSpace)(7, step) };
        }
        case 11: {
            return { size: "".concat((0, polished_1.rem)(scale[10])), lineHeight: (0, calc_space_1.calcSpace)(8, step) };
        }
        case 0:
        default: {
            return { size: "".concat((0, polished_1.rem)(scale[4])), lineHeight: (0, calc_space_1.calcSpace)(3.5, step) };
        }
    }
};
exports.getFontScale = getFontScale;
//# sourceMappingURL=get-font-scale.js.map